import React from "react";
import { Helmet } from "react-helmet";
// 동적인 코드 없다면 없애도 되는 컴포넌트이다.

function DynamicHeader(props) {
  return (
    <Helmet>
      {/* https://developers.google.com/fonts/docs/css2 */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link
        href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&family=Noto+Sans+KR:wght@100..900&family=Roboto:wght@400;500;700;900&display=block"
        rel="stylesheet"
      />

      {/* favicon */}
      {/* <link
        rel="icon"
        type="image/png"
        href="https://content.maunent.com/favicon/favicon-196x196.png"
        sizes="196x196"
      />
      <link
        rel="icon"
        type="image/png"
        href="https://content.maunent.com/favicon/favicon-96x96.png"
        sizes="96x96"
      />
      <link
        rel="icon"
        type="image/png"
        href="https://content.maunent.com/favicon/favicon-32x32.png"
        sizes="32x32"
      />
      <link
        rel="icon"
        type="image/png"
        href="https://content.maunent.com/favicon/favicon-16x16.png"
        sizes="16x16"
      />
      <link
        rel="icon"
        type="image/png"
        href="https://content.maunent.com/favicon/favicon-128.png"
        sizes="128x128"
      /> */}

      {/* ios용 pwa 설정 */}
      <meta name="apple-mobile-web-app-title" content="Maunent" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="application-name" content="Maunent" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />

      {/* ios용 icon */}
      <link
        rel="apple-touch-icon"
        sizes="57x57"
        href="https://content.maunent.com/favicon/icon-57x57.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="72x72"
        href="https://content.maunent.com/favicon/icon-72x72.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="76x76"
        href="https://content.maunent.com/favicon/icon-76x76.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="114x114"
        href="https://content.maunent.com/favicon/icon-114x114.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="120x120"
        href="https://content.maunent.com/favicon/icon-120x120.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="144x144"
        href="https://content.maunent.com/favicon/icon-144x144.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="152x152"
        href="https://content.maunent.com/favicon/icon-152x152.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="167x167"
        href="https://content.maunent.com/favicon/icon-167x167.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="https://content.maunent.com/favicon/icon-180x180.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="512x512"
        href="https://content.maunent.com/favicon/icon-512x512.png"
      />
    </Helmet>
  );
}

export default DynamicHeader;
